import React from "react";

import { Box, Grid } from "@mui/material";
import { Typography } from "@mui/material";

const PrivacyPolicy = () => {
  return (
    <div className="ds">
      <Grid container className="digital-solution-page-b ">
        <Grid item sm={6} xs={6} className="padded-container6 left-align padding-left-col">
          <Box component="div" className="privacy-policy-content-container">
            <Typography variant="subtitle2" className="info-text ">
              Datenschutzerklärung
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Nachstehende Datenschutzerklärung gilt für die Webseite „volksbank-digital.solutions“.
            </Typography>
            <Typography variant="subtitle2" className="info-text ">
              Nachstehende Datenschutzerklärung gilt für die Webseite „volksbank-digital.solutions“.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Nachstehende Datenschutzerklärung gilt für die Webseite „volksbank-digital.solutions“.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Volksbank Digital Solutions GmbH
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              vertreten durch die Geschäftsführer Stefan Spohrer und Andreas Lorenz
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              info@volksbank.solutions
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              II. Zweck der Verarbeitung von personenbezogenen Daten, Rechtsgrundlage und
              Speicherdauer
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Nachfolgend informieren wir Sie über die auf unserer Seite stattfindenden
              Datenverarbeitungen (a), deren Zwecke (b), Rechtsgrundlage (c) sowie jeweilige
              Speicherdauer und ggf. konkrete Widerspruchs- und Beseitigungsmöglichkeiten (d).
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              1. Logfiles
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              a) Beim Aufrufen unserer Website werden durch den auf Ihrem Endgerät zum Einsatz
              kommenden Browser automatisch Informationen an den Server unserer Website gesendet.
              Diese Informationen werden temporär in einem sog. Logfile gespeichert. Folgende
              Informationen werden dabei ohne Ihr Zutun erfasst und bis zur automatisierten Löschung
              gespeichert:
            </Typography>
            <br></br>
            <ul>
              <li>
                <Typography variant="subtitle2" className="info-text ">
                  IP-Adresse des anfragenden Rechners
                </Typography>
              </li>
              <li>
                <Typography variant="subtitle2" className="info-text ">
                  Datum und Uhrzeit des Aufrufs
                </Typography>
              </li>
              <li>
                <Typography variant="subtitle2" className="info-text ">
                  Name und URL der aufgerufenen Webseite
                </Typography>
              </li>
              <li>
                <Typography variant="subtitle2" className="info-text ">
                  Website, von der aus der Zugriff erfolgt (Referrer-URL)
                </Typography>
              </li>
              <li>
                <Typography variant="subtitle2" className="info-text ">
                  verwendeter Browser, Version des Browsers
                </Typography>
              </li>
              <li>
                <Typography variant="subtitle2" className="info-text ">
                  Betriebssystem und Version des Betriebssystems Ihres Rechners sowie der Name Ihres
                  Access-Providers
                </Typography>
              </li>
              <li>
                <Typography variant="subtitle2" className="info-text ">
                  Übertragene Datenmengen und der Zugriffsstatus (Datei übertragen, Datei nicht
                  gefunden, etc.)
                </Typography>
              </li>
              <li>
                <Typography variant="subtitle2" className="info-text ">
                  Sprache und Version der Browsersoftware
                </Typography>
              </li>
            </ul>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              b) Die genannten Daten werden von uns zu folgenden Zwecken verarbeitet:
            </Typography>
            <br></br>
            <ul>
              <li>
                <Typography variant="subtitle2" className="info-text ">
                  Gewährleistung eines reibungslosen Verbindungsaufbaus der Website,
                </Typography>
              </li>
              <li>
                <Typography variant="subtitle2" className="info-text ">
                  Gewährleistung einer komfortablen Nutzung unserer Website,
                </Typography>
              </li>
              <li>
                <Typography variant="subtitle2" className="info-text ">
                  Auswertung der Systemsicherheit und -stabilität sowie
                </Typography>
              </li>
              <li>
                <Typography variant="subtitle2" className="info-text ">
                  zu weiteren administrativen Zwecken.
                </Typography>
              </li>
            </ul>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              c) Die Rechtsgrundlage für die Datenverarbeitung ist Art. 6 Abs. 1 S. 1 lit. f DSGVO.
              Unser berechtigtes Interesse folgt aus oben aufgelisteten Zwecken zur
              Datenverarbeitung. In keinem Fall verwenden wir die erhobenen Daten zu dem Zweck,
              Rückschlüsse auf Ihre Person zu ziehen
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              d) Die Daten in den Logfiles werden spätestens nach 7 Tagen gelöscht.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              2. Cookies
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              a) Wir setzen auf unserer Seite Cookies ein. Hierbei handelt es sich um kleine
              Dateien, die Ihr Browser automatisch erstellt und die auf Ihrem Endgerät (Laptop,
              Tablet, Smartphone o.ä.) gespeichert werden, wenn Sie unsere Seite besuchen. Cookies
              richten auf Ihrem Endgerät keinen Schaden an, enthalten keine Viren, Trojaner oder
              sonstige Schadsoftware.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              In dem Cookie werden Informationen abgelegt, die sich jeweils im Zusammenhang mit dem
              spezifisch eingesetzten Endgerät ergeben. Dies bedeutet jedoch nicht, dass wir dadurch
              unmittelbar Kenntnis von Ihrer Identität erhalten.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Wir setzen folgende Cookies ein:
            </Typography>
            <br></br>
            <ul>
              <li>
                <Typography variant="subtitle2" className="info-text ">
                  Session Cookies
                </Typography>
              </li>
            </ul>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Die meisten Browser akzeptieren Cookies automatisch. Sie können Ihren Browser jedoch
              so konfigurieren, dass keine Cookies auf Ihrem Computer gespeichert werden oder stets
              ein Hinweis erscheint, bevor ein neuer Cookie angelegt wird. Die vollständige
              Deaktivierung von Cookies kann jedoch dazu führen, dass Sie nicht alle Funktionen
              unserer Website nutzen können.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              b) Der Einsatz von Cookies dient einerseits dazu, die Nutzung unseres Angebots für Sie
              angenehmer zu gestalten.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              So setzen wir sogenannte Session-Cookies ein, um zu erkennen, dass Sie einzelne Seiten
              unserer Website bereits besucht haben.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Darüber hinaus setzen wir ebenfalls zur Optimierung der Benutzerfreundlichkeit weitere
              temporäre Cookies ein, die für einen bestimmten festgelegten Zeitraum auf Ihrem
              Endgerät gespeichert werden. Besuchen Sie unsere Seite erneut, um unsere Dienste in
              Anspruch zu nehmen, wird automatisch erkannt, dass Sie bereits bei uns waren und
              welche Eingaben und Einstellungen sie getätigt haben, um diese nicht noch einmal
              eingeben zu müssen.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Zum anderen setzten wir Cookies ein, um die Nutzung unserer Website pseudonymisiert
              und rein statistisch zu erfassen und auswerten zu können, um unser Angebot für Sie
              noch weiter zu optimieren. Diese Cookies ermöglichen es uns, bei einem erneuten Besuch
              unserer Seite automatisch zu erkennen, dass Sie bereits bei uns waren. Die
              Drittanbieter der zugehörigen Analysetools setzen hierzu entsprechende Cookies ein
              (die Einzelheiten ergeben sich dazu bei den nachfolgenden Beschreibungen der
              zugehörigen Drittanbieter-Dienste).
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              c) Cookies, die zur Durchführung des elektronischen Kommunikationsvorgangs (notwendige
              Cookies) oder zur Bereitstellung bestimmter, von Ihnen erwünschter Funktionen
              (funktionale Cookies) erforderlich sind, werden auf Grundlage von § 25 II Nr. 2 TTDSG
              gespeichert, sofern keine andere Rechtsgrundlage angegeben wird. Der Websitebetreiber
              hat ein berechtigtes Interesse an der Speicherung von Cookies zur technisch
              fehlerfreien und optimierten Bereitstellung seiner Dienste. Sofern eine Einwilligung
              zur Speicherung von Cookies abgefragt wurde, erfolgt die Speicherung der betreffenden
              Cookies ausschließlich auf Grundlage dieser Einwilligung (§ 25 I TTDSG); die
              Einwilligung ist jederzeit widerrufbar.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              d) Session Cookies werden nach Verlassen unserer Seite automatisch gelöscht. Temporäre
              Cookies werden nach einer jeweils definierten Zeit, hier 24 Stunden automatisch
              gelöscht. Cookies zu Analysezwecken bzw. Drittanbieter-Cookies werden nach den durch
              die jeweiligen Anbieter vorgegebenen Zeiten automatisch gelöscht.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Sie können die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer
              Browser-Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall
              gegebenenfalls nicht sämtliche Funktionen dieser Website vollumfänglich werden nutzen
              können. Sie können bereits gespeicherte Cookies jederzeit in den
              Sicherheitseinstellungen Ihres Browsers löschen.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              3. Matomo
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              a) und b){" "}
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Auf dieser Website nutzen wir den Webanalysedienst Matomo, um die Nutzung unserer
              Website zu analysieren und prüfen. Über die gewonnenen Statistiken können wir unser
              Angebot verbessern und für Sie als Nutzer interessanter ausgestalten.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Wir betreiben Matomo in einer Version, die keine Cookies benötigt. Es werden zum Zweck
              der Webanalyse also keine Matomo-Cookies auf Ihrem Computer gespeichert. Für die
              Analyse der Website-Nutzung werden Ihre IP-Adresse und Informationen wie Zeitstempel,
              besuchte Webseiten und Ihre Spracheinstellungen erfasst. Die so erhobenen
              Informationen speichern wir auf unserem Server.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              c) Diese Website verwendet Matomo mit der Erweiterung „AnonymizeIP“. Dadurch werden
              IP-Adressen gekürzt weiterverarbeitet und eine direkte Personenbeziehbarkeit
              ausgeschlossen. Die mittels Matomo von Ihrem Browser übermittelte IP-Adresse wird
              nicht mit anderen von uns erhobenen Daten zusammengeführt. Rechtsgrundlage für die
              Nutzung von Matomo ist Art. 6 Abs. 1 S. 1 lit. f DS-GVO
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              d) Die Verhinderung des Einsatzes von Matomo ist möglich, indem Sie den folgenden
              Haken entfernen und so das Opt-out-Plug-in aktivieren: [Matomo iFrame]. In diesem Fall
              wird in Ihrem Browser ein Opt-out-Cookie hinterlegt, der verhindert, dass Matomo
              Nutzungsdaten speichert. Wenn Sie Ihre Cookies löschen, hat das zur Folge, dass auch
              das Matomo Opt-out-Cookie gelöscht wird. Das Opt-out muss bei einem erneuten Besuch
              unserer Seite wieder aktiviert werden.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Das Programm Matomo ist ein Open-Source-Projekt. Informationen des Drittanbieters zum
              Datenschutz erhalten Sie unter matomo.org/privacy-policy/.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              4. Registrierung des Benutzerkontos
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              a) und b)
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Auf unserer Homepage finden Sie zudem den Login-Bereich für unser VDS-Portal. Um
              dieses nutzen zu können benötigen Sie eigene Zugangsdaten. Diese erhalten Sie durch
              die Administratoren Ihrer Organisation, wenn Sie als Nutzer für das Portal vorgesehen
              sind. Eine eigenständige Registrierung ist nicht möglich.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Für die Nutzung des Portals sind E-Mail Adresse und ein selbstgewähltes Passwort
              notwendig. Um dieses zu setzen, erhalten Sie eine E-Mail mit einem entsprechenden
              Link.{" "}
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              c) Wenn Sie unser Portal nutzen, speichern wir Ihre zur Vertragserfüllung
              erforderlichen Daten, auch bis Sie Ihren Zugang endgültig löschen. Rechtsgrundlage ist
              Art. 6 Abs. 1 S. 1 lit. b DS-GVO.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              d) Die Daten werden gelöscht, sobald sie für die Erreichung des Zwecks ihrer Erhebung
              nicht mehr erforderlich sind.{" "}
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Dient die Registrierung der Erfüllung eines Vertrages, oder zur Durchführung
              vorvertraglicher Maßnahmen, werden die Daten gelöscht, wenn sie für die Durchführung
              des Vertrages nicht mehr erforderlich sind. Auch nach Abschluss des Vertrages kann
              eine Erforderlichkeit, personenbezogene Daten des Vertragspartners zu speichern,
              bestehen, um vertraglichen oder gesetzlichen Verpflichtungen nachzukommen. Die
              gesetzlichen Aufbewahrungsfristen betragen 6 Jahre nach Ablauf des Jahres in dem der
              Vertrag beendet wurde, es sei denn, dass wir aufgrund von steuer- und
              handelsrechtlichen Aufbewahrungs- und Dokumentationspflichten (aus HGB, StGB oder AO)
              zu einer längeren Speicherung verpflichtet sind oder Sie in eine darüber hinausgehende
              Speicherung nach Art. 6 Abs. 1 S. 1 lit. a DSGVO eingewilligt haben.{" "}
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              III. Zusammenarbeit mit Auftragsverarbeitern und Dritten
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Teilweise bedienen wir uns zur Verarbeitung Ihrer Daten externer Dienstleister
              (Auftragsverarbeiter). Diese wurden von uns sorgfältig ausgewählt und beauftragt, sind
              an Weisungen gebunden und werden regelmäßig kontrolliert. Dies sind externe
              Dienstleister, die uns in technischer Hinsicht unterstützen (Webhoster,
              Programmierer). Dies geschieht auf Grundlage von Auftragsverarbeitungsverträgen gem.
              Art. 28 DSGVO.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Teilweise bedienen wir uns zur Verarbeitung Ihrer Daten externer Dienstleister
              (Auftragsverarbeiter). Diese wurden von uns sorgfältig ausgewählt und beauftragt, sind
              an Weisungen gebunden und werden regelmäßig kontrolliert. Dies sind externe
              Dienstleister, die uns in technischer Hinsicht unterstützen (Webhoster,
              Programmierer). Dies geschieht auf Grundlage von Auftragsverarbeitungsverträgen gem.
              Art. 28 DSGVO.
            </Typography>
            <br></br>
            <ul>
              <li>
                <Typography variant="subtitle2" className="info-text ">
                  Sie Ihre nach Art. 6 Abs. 1 S. 1 lit. a DSGVO ausdrückliche Einwilligung dazu
                  erteilt haben,
                </Typography>
              </li>
              <br></br>
              <li>
                <Typography variant="subtitle2" className="info-text ">
                  die Weitergabe nach Art. 6 Abs. 1 S. 1 lit. f DSGVO zur Geltendmachung, Ausübung
                  oder Verteidigung von Rechtsansprüchen erforderlich ist und kein Grund zur Annahme
                  besteht, dass Sie ein überwiegendes schutzwürdiges Interesse an der
                  Nichtweitergabe Ihrer Daten haben,
                </Typography>
              </li>
              <br></br>
              <li>
                <Typography variant="subtitle2" className="info-text ">
                  für die Weitergabe nach Art. 6 Abs. 1 S. 1 lit. c DSGVO eine gesetzliche
                  Verpflichtung besteht, oder
                </Typography>
              </li>
              <br></br>
              <li>
                <Typography variant="subtitle2" className="info-text ">
                  für die Weitergabe nach Art. 6 Abs. 1 S. 1 lit. c DSGVO eine gesetzliche
                  Verpflichtung besteht, oder
                </Typography>
              </li>
              <br></br>
            </ul>
            <Typography variant="subtitle2" className="info-text ">
              Eine Beauftragung von Dienstleistern in einem Drittland erfolgt nur, wenn die
              besonderen Voraussetzungen der Art. 44 ff. DSGVO erfüllt sind.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              IV. Betroffenenrechte
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Sie haben das Recht:
            </Typography>
            <br></br>
            <ul>
              <li>
                <Typography variant="subtitle2" className="info-text ">
                  gemäß Art. 15 DSGVO Auskunft über Ihre von uns verarbeiteten personenbezogenen
                  Daten zu verlangen. Insbesondere können Sie Auskunft über die Verarbeitungszwecke,
                  die Kategorie der personenbezogenen Daten, die Kategorien von Empfängern,
                  gegenüber denen Ihre Daten offengelegt wurden oder werden, die geplante
                  Speicherdauer, das Bestehen eines Rechts auf Berichtigung, Löschung, Einschränkung
                  der Verarbeitung oder Widerspruch, das Bestehen eines Beschwerderechts, die
                  Herkunft ihrer Daten, sofern diese nicht bei uns erhoben wurden, sowie über das
                  Bestehen einer automatisierten Entscheidungsfindung einschließlich Profiling und
                  ggf. aussagekräftigen Informationen zu deren Einzelheiten verlangen;
                </Typography>
              </li>
              <br></br>
              <li>
                <Typography variant="subtitle2" className="info-text ">
                  gemäß Art. 16 DSGVO unverzüglich die Berichtigung unrichtiger oder
                  Vervollständigung Ihrer bei uns gespeicherten personenbezogenen Daten zu
                  verlangen;
                </Typography>
              </li>
              <br></br>
              <li>
                <Typography variant="subtitle2" className="info-text ">
                  gemäß Art. 17 DSGVO die Löschung Ihrer bei uns gespeicherten personenbezogenen
                  Daten zu verlangen, soweit nicht die Verarbeitung zur Ausübung des Rechts auf
                  freie Meinungsäußerung und Information, zur Erfüllung einer rechtlichen
                  Verpflichtung, aus Gründen des öffentlichen Interesses oder zur Geltendmachung,
                  Ausübung oder Verteidigung von Rechtsansprüchen erforderlich ist;
                </Typography>
              </li>
              <br></br>
              <li>
                <Typography variant="subtitle2" className="info-text ">
                  gemäß Art. 18 DSGVO die Einschränkung der Verarbeitung Ihrer personenbezogenen
                  Daten zu verlangen, soweit die Richtigkeit der Daten von Ihnen bestritten wird,
                  die Verarbeitung unrechtmäßig ist, Sie aber deren Löschung ablehnen und wir die
                  Daten nicht mehr benötigen, Sie jedoch diese zur Geltendmachung, Ausübung oder
                  Verteidigung von Rechtsansprüchen benötigen oder Sie gemäß Art. 21 DSGVO
                  Widerspruch gegen die Verarbeitung eingelegt haben;
                </Typography>
              </li>
              <br></br>
              <li>
                <Typography variant="subtitle2" className="info-text ">
                  gemäß Art. 20 DSGVO Ihre personenbezogenen Daten, die Sie uns bereitgestellt
                  haben, in einem strukturierten, gängigen und maschinenlesebaren Format zu erhalten
                  oder die Übermittlung an einen anderen Verantwortlichen zu verlangen;
                </Typography>
              </li>
              <br></br>
              <li>
                <Typography variant="subtitle2" className="info-text ">
                  gemäß Art. 20 DSGVO Ihre personenbezogenen Daten, die Sie uns bereitgestellt
                  haben, in einem strukturierten, gängigen und maschinenlesebaren Format zu erhalten
                  oder die Übermittlung an einen anderen Verantwortlichen zu verlangen;
                </Typography>
              </li>
              <br></br>
            </ul>
            <Typography variant="subtitle2" className="info-text ">
              V. Widerspruchsrecht
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Sofern Ihre personenbezogenen Daten auf Grundlage von berechtigten Interessen gemäß
              Art. 6 Abs. 1 S. 1 lit. f DSGVO verarbeitet werden, haben Sie das Recht, gemäß Art. 21
              DSGVO Widerspruch gegen die Verarbeitung Ihrer personenbezogenen Daten einzulegen,
              soweit dafür Gründe vorliegen, die sich aus Ihrer besonderen Situation ergeben; dies
              gilt auch für ein auf diese Bestimmungen gestütztes Profiling. Wir verarbeiten die Sie
              betreffenden personenbezogenen Daten nicht mehr, es sei denn wir können zwingende
              schutzwürdige Gründe für die Verarbeitung nachweisen, die Ihre Interessen, Rechte und
              Freiheiten überwiegen, oder die Verarbeitung dient der Geltendmachung, Ausübung oder
              Verteidigung von Rechtsansprüchen.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Selbstverständlich können Sie der Verarbeitung Ihrer personenbezogenen Daten für
              Zwecke der Werbung und Datenanalyse jederzeit widersprechen. Dies gilt auch für das
              Profiling, soweit es mit solcher Direktwerbung in Verbindung steht.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              VI. Recht auf Widerruf der datenschutzrechtlichen Einwilligung
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Sie haben gemäß Art. 7 Abs. 3 DSGVO das Recht, Ihre einmal erteilte Einwilligung
              jederzeit gegenüber uns zu widerrufen. Dies hat zur Folge, dass wir die
              Datenverarbeitung, die auf dieser Einwilligung beruhte, für die Zukunft nicht mehr
              fortführen dürfen. Die Rechtmäßigkeit, der aufgrund der Einwilligung bis zum Widerruf
              erfolgten Verarbeitung, wird hierdurch nicht berührt.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              VII. Aktualität und Änderungen dieser Datenschutzerklärung
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Diese Datenschutzerklärung hat den Stand Dezember 2022.
            </Typography>
            <br></br>
            <Typography variant="subtitle2" className="info-text ">
              Durch die Weiterentwicklung unserer Website und Angebote darüber oder aufgrund
              geänderter gesetzlicher beziehungsweise behördlicher Vorgaben kann es notwendig
              werden, diese Datenschutzerklärung zu ändern.{" "}
            </Typography>
            <br></br>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};

export default PrivacyPolicy;
